import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetAutoPopupCounter } from "@/components/FirstTimeHint";

const RouteScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
    resetAutoPopupCounter();
  }, [pathname]);

  return null;
};

export default RouteScrollToTop;
